import mrApi from './mrApi';

export default {
  getShopCategoriesForKeys,
};

export function getShopCategoriesForKeys(params) {
  return mrApi.get('/api/shopCategories/shopCategoriesForKeys', { params });
}